import React, { useState, useMemo } from "react";
import { useApp } from "@/context/AppContext";
import { ALL_PRODUCTS, CATEGORIES, categoryOf } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";

export default function Catalogue() {
  const { t, lang } = useApp();
  const [cat, setCat] = useState("all");

  const products = useMemo(
    () => (cat === "all" ? ALL_PRODUCTS : ALL_PRODUCTS.filter((p) => categoryOf(p) === cat)),
    [cat]
  );

  return (
    <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8" data-testid="catalogue-page">
      <header className="mb-10">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-cea-accent">{t.nav.catalogue}</p>
        <h1 className="mt-3 text-4xl font-extrabold tracking-tighter text-cea-ink sm:text-5xl">{t.catalogue.title}</h1>
        <p className="mt-3 max-w-2xl text-slate-500">{t.catalogue.sub}</p>
      </header>

      <div className="flex flex-col gap-8 lg:flex-row">
        {/* Filters */}
        <aside className="lg:w-56 lg:shrink-0">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.15em] text-slate-400">{t.catalogue.filter}</p>
          <div className="flex flex-wrap gap-2 lg:flex-col">
            {CATEGORIES.map((c) => (
              <button
                key={c.key}
                onClick={() => setCat(c.key)}
                data-testid={`filter-${c.key}`}
                className={`rounded-full px-4 py-2 text-left text-sm font-medium transition-colors lg:rounded-xl ${
                  cat === c.key ? "bg-cea-navy text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {c[lang]}
              </button>
            ))}
          </div>
        </aside>

        {/* Grid */}
        <div className="flex-1">
          {products.length === 0 ? (
            <p className="text-slate-500" data-testid="catalogue-empty">{t.catalogue.empty}</p>
          ) : (
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="catalogue-grid">
              {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
